import axios from "axios";
import { axiosApi } from "../axios";
import { fileInstructions, MailFolder } from "../types/filing";
import { getGraphToken } from "./auth";

const GRAPH_BASE = "https://graph.microsoft.com/v1.0";

export const fileItems = async (
  userId: string,
  itemIds: string[],
  folderId: string
): Promise<{ success: true }> => {
  const body: fileInstructions = {
    messages: itemIds.map((id) => ({ id, folderId }))
  };
  await axiosApi.post(`/users/${userId}/file`, body);
  return { success: true };
};

type GraphMailFolderResponse = {
  value: Array<{ id: string; displayName: string; childFolderCount: number }>;
};

// Fetches mail folders directly from Microsoft Graph. Pass a parentFolderId to
// load its immediate children; omit for top-level folders. Called incrementally
// as the user expands nodes in the folder tree.
export const getFolders = async (parentFolderId?: string): Promise<MailFolder[]> => {
  const token = await getGraphToken();
  const url = parentFolderId
    ? `${GRAPH_BASE}/me/mailFolders/${parentFolderId}/childFolders?$top=100`
    : `${GRAPH_BASE}/me/mailFolders?$top=100`;

  const response = await axios.get<GraphMailFolderResponse>(url, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data.value.map((f) => ({
    id: f.id,
    displayName: f.displayName,
    childFolderCount: f.childFolderCount,
  }));
};

export const createFolder = async (
  parentFolderId: string | null,
  displayName: string
): Promise<MailFolder> => {
  const token = await getGraphToken();
  const url = parentFolderId
    ? `${GRAPH_BASE}/me/mailFolders/${parentFolderId}/childFolders`
    : `${GRAPH_BASE}/me/mailFolders`;
  const response = await axios.post<{ id: string; displayName: string; childFolderCount: number }>(
    url,
    { displayName },
    { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
  );
  const f = response.data;
  return { id: f.id, displayName: f.displayName, childFolderCount: f.childFolderCount };
};

// //Todo: remove this function when mockfiling suggsestions are removed
// type TranslateIdResponse = {
//   value: Array<{ sourceId: string; targetId: string }>;
// };
//
// const translateExchangeIds = async (
//   inputIds: string[],
//   sourceIdType: "restId" | "restImmutableEntryId",
//   targetIdType: "restId" | "restImmutableEntryId"
// ): Promise<Record<string, string>> => {
//   if (inputIds.length === 0) return {};
//   const token = await getGraphToken();
//   const response = await axios.post<TranslateIdResponse>(
//     `${GRAPH_BASE}/me/translateExchangeIds`,
//     { inputIds, sourceIdType, targetIdType },
//     { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
//   );
//   return response.data.value.reduce((acc, v) => {
//     acc[v.sourceId] = v.targetId;
//     return acc;
//   }, {} as Record<string, string>);
// };
//
// // Resolves a mutable REST v2 id to its Microsoft Graph immutable id via the
// // dedicated id-translation endpoint (no message body is fetched).
// export const translateToImmutableId = async (restId: string): Promise<string | undefined> => {
//   const translated = await translateExchangeIds([restId], "restId", "restImmutableEntryId");
//   return translated[restId];
// };
//
// // Resolves a batch of Microsoft Graph immutable ids back to their current
// // (mutable) REST v2 ids, keyed by the input immutable id.
// export const translateImmutableIdsToRestIds = async (
//   immutableIds: string[]
// ): Promise<Record<string, string>> => translateExchangeIds(immutableIds, "restImmutableEntryId", "restId");
